<template>
    <div class="buttons" v-if="notSent">
        <b-button variant="default" @click="$bvModal.show(sendModalId)" size="xs">
            <font-awesome-icon :icon="['fas', 'paper-plane']"/>
        </b-button>
        <b-button variant="default" @click="$bvModal.show(deleteModalId)" size="xs">
            <font-awesome-icon :icon="['fas', 'trash']"/>
        </b-button>        
        <modal title="Send Email Confirm" :id="sendModalId" @ok="handleSendEmail" @shown="onModalShown">
            Are you sure you want to send this deferred email?
        </modal>
        <modal title="Delete Email Confirm" :id="deleteModalId" @ok="handleDeleteEmail" @shown="onModalShown">
            Are you sure you want to delete this deferred email?
        </modal>
    </div>
</template>

<script>
import API from '../../../api';
import { formatResponseError } from '../../../utils/api';
import { ADMIN_DEFERRED_EMAILS_REPORT_ENDPOINT } from '../../../endpoints';
import Modal from '../../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    data() {
        return {
            deleteModalId: null,
            sendModalId: null,
            notSent: false,
        };
    },
    mounted() {
        this.notSent = !this.params?.data?.sent;
        this.emailId = this.params?.data?.id;
        this.sendModalId = 'send-modal-' + this.params?.data?.id.toString();
        this.deleteModalId = 'delete-modal-' + this.params?.data?.id.toString();
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        async handleDeleteEmail() {
            try {
                await API.delete(ADMIN_DEFERRED_EMAILS_REPORT_ENDPOINT(this.emailId));
                this.params.refresh();
                this.successToast({ text: `Deferred email successfully deleted.` });
            } catch (error) {
                const { generic, fields } = formatResponseError(error);
                this.errorToast({
                    text: `Could not delete deferred email.`,
                });
            }
        },
        async handleSendEmail() {
            try {
                await API.post(`${ADMIN_DEFERRED_EMAILS_REPORT_ENDPOINT(this.emailId)}send/`);
                this.params.refresh();
                this.successToast({ text: `Deferred email successfully sent.` });
            } catch (error) {
                const { generic, fields } = formatResponseError(error);
                this.errorToast({
                    text: `Could not send deferred email.`,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.buttons {
    display: flex;
    justify-content: center;
}
</style>
